import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { dom } from "@fortawesome/fontawesome-svg-core";

Vue.component("fa", FontAwesomeIcon);
dom.watch();

// Import autogenerated fontawesome imports
import "./fontawesome-autoimport.js";
